<template>
  <ul class="pair-list-container">
    <li class="pair list-item"
      v-for="item in computedItems"
      :key="item.type + item.value"
    >
      <h4 class="type text-caps">{{item.type}}</h4>
      <h3 class="value text-description">{{item.value}}</h3>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PairList',
  props: {
    items: Array,
  },
  computed: {
    computedItems() {
      return this.items && this.items.filter(item => {
        return item.type && item.value; 
      }) || []; 
    },
  },
}
</script>

<style lang="sass">
@import '../assets/partials/vars'

.pair-list-container
  display: flex
  flex-wrap: wrap
  margin-bottom: 4rem
  .list-item
    width: 50%
    padding-right: 5%
    margin-bottom: 3rem
    .type
    .value

+after-bg-mobile 
  .pair-list-container
    .list-item
      padding-right: 8%
      .type
      .value

</style>
